/* ------------------------------------------------------ */
/* Set page title --------------------------------------- */
/* ------------------------------------------------------ */

import { useState, useEffect } from 'react'
import { Location } from 'react-router-dom'

const usePageTitle = (location: Location): string => {
  const [pageTitle, setPageTitle] = useState('Dashboard')

  useEffect(() => {
    switch (location.pathname) {
      case '/uebersicht':
        setPageTitle('Übersicht')
        break
      case '/vertraege':
        setPageTitle('Meine Verträge')
        break
      case '/zaehlerstaende':
        setPageTitle('Zählerstände')
        break
      case '/rechnungen':
        setPageTitle('Zahlung & Rechnungsadresse')
        break
      case '/abschlaege':
        setPageTitle('Abschläge')
        break
      case '/profile':
        setPageTitle('Mein Profil')
        break
      case '/helpandcontact':
        setPageTitle('Hilfe & Kontakt')
        break
      default:
        setPageTitle('Übersicht')
    }
  }, [location.pathname])

  return pageTitle
}

export default usePageTitle
